import { requestType, CREATOR_ENDPOINTS } from "../../constants/Variables";
import Api from "../index";

const creatorSendCode = (params) => {
  return Api(
    CREATOR_ENDPOINTS.AUTHENTICATION.SEND_CODE,
    params,
    requestType.POST,
  );
};

const registerCreator = (params) => {
  return Api(
    CREATOR_ENDPOINTS.AUTHENTICATION.REGISTER,
    params,
    requestType.POST,
  );
};

const loginCreator = (params) => {
  return Api(CREATOR_ENDPOINTS.AUTHENTICATION.LOGIN, params, requestType.POST);
};

const creatorUpdateProfile = (id, params) => {
  return Api(
    CREATOR_ENDPOINTS.AUTHENTICATION.UPDATE_PROFILE.replace(":id", id),
    params,
    requestType.PUT,
  );
};

const changePasswordCreator = (params) => {
  return Api(
    CREATOR_ENDPOINTS.AUTHENTICATION.CHANGE_PASSWORD,
    params,
    requestType.POST,
  );
};

export {
  creatorSendCode,
  registerCreator,
  loginCreator,
  creatorUpdateProfile,
  changePasswordCreator,
};
